import React from 'react';
import './platform-tabs.less';
import { Tabs } from './tabs';
import { ProductContext } from '../../../content';
import { AnalyticsMetadata } from '../../utils/analytics/types';
import { ProductCardsGroup } from '../product-card';
import analytics from '../../utils/analytics';
import { camelCase } from 'lodash';

interface PlatformTabsProps {
    cloudProducts: ProductContext[];
    serverProducts: ProductContext[];
    details: string;
    analyticsMetadata: AnalyticsMetadata;
}

const handleTabSelect = (details: string, tab: string) => {
    const tabName = tab === 'Data Center' ? 'Server' : tab;
    analytics.trackEvent(camelCase(tabName + ' tab'), {
        event: 'clicked',
        eventComponent: 'tab',
        category: 'products cloud and server tabs',
        actionSubjectId: camelCase(details + ' products ' + tabName + ' tab'),
        action: 'click',
        label: tab
    });
};

const handleKeyDown = (details: string, tab: string, keyboardEvent: string) => {
    const tabName = tab === 'Data Center' ? 'Server' : tab;
    analytics.trackEvent(camelCase(tabName + ' tab'), {
        event: 'keyboard',
        eventComponent: 'tab',
        category: 'products cloud and server tabs',
        actionSubjectId: camelCase(details + ' products ' + tabName + ' tab'),
        action: 'selected',
        label: tab,
        keyboardEvent
    });
};

export const PlatformTabs = ({
    cloudProducts,
    serverProducts,
    details,
    analyticsMetadata
}: PlatformTabsProps) => {
    const tabs = [
        {
            label: 'Cloud',
            content: (
                <ProductCardsGroup
                    productList={cloudProducts}
                    analyticsMetadata={analyticsMetadata}
                    renderV2={true}
                />
            )
        },
        {
            label: 'Data Center',
            content: (
                <ProductCardsGroup
                    productList={serverProducts}
                    analyticsMetadata={analyticsMetadata}
                    renderV2={true}
                />
            )
        }
    ];

    return (
        <Tabs
            tabs={tabs}
            onSelect={(selected) => {
                selected.label && handleTabSelect(details, selected.label);
            }}
            onKeyDown={(selected, keyboardEvent) => {
                selected.label &&
                    handleKeyDown(details, selected.label, keyboardEvent);
            }}
        />
    );
};
